module.exports = __webpack_public_path__ + "static/media/icon_plus_turquoise.cefdff48.svg";